import { useGateValue } from "@statsig/react-bindings";

export const useEnableUcDashboard = (): boolean => {
  return useGateValue("enable_uc_dashboard");
};
